/* eslint-disable */
import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
// import { Tooltip as TooltipPlugin } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend, ChartDataLabels);

const VarianceBarChart = ({ data }) => {

  const values = data.map((item) => Number(item.value || 0));
  const labels = data.map((item) => item.label);

  const chartData = {
    labels,
    datasets: [
      {
        label: 'Variance',
        data: values,
        // backgroundColor: '#800080',
        backgroundColor: (ctx) => {
          const value = ctx.raw;
          return value < 0 ? "red" : "#800080";
        },
        borderRadius: 2,
        barPercentage: 0.7,
        categoryPercentage: 0.7,
        barThickness: 30,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: 'nearest',
      intersect: true,
    },
    layout: {
      padding: {
        top: 20,
      },
    },
    plugins: {
      legend: { display: false },
      tooltip: {
        enabled: true,
        position: 'nearest',
        backgroundColor: '#333',
        titleFont: { size: 12 },
        bodyFont: { size: 9 },
        padding: 5,
        cornerRadius: 6,
        boxPadding: 5,
        displayColors: false,
        callbacks: {
          label: (ctx) => {
            const val = ctx.parsed?.y ?? ctx.raw;
            return `${ctx.dataset.label}: ${val} %`;
          },
        },
      },
      datalabels: {
        color: "black",
        textStrokeColor: "white",
        textStrokeWidth: 4,
        anchor: "end",
        align: "end",
        // rotation: 90, 
        // display: "auto",
        // clip: "auto",
        font: {
          weight: "bold",
          size: 10,
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: { display: true,
          font: {
            size: 8,
            // weight: 'bold',
          },
         },
        grid: { display: true },
        border: { display: true },
      },
      x: {
        ticks: {
          display: true,
          font: {
            size: 8,
            weight: "bold",
          },
        },
      },
    },
  };


  return (
    <div style={{ width: '100%', height: '150px' }}>
      <Bar data={chartData} options={options} />
    </div>
  );
};

export default VarianceBarChart;

